import React, {Fragment, useEffect, useState} from "react"
import {Button, Descriptions, Popover} from "antd"
import moment from "moment"
import TicketOrderStatus from "../../components/TicketOrderStatus"
import QRCode from 'qrcode'

const Item = Descriptions.Item

const Info = ({
                item = {}
              }) => {

  const [ticketCodeImage, setTicketCodeImage] = useState('')

  useEffect(() => {
    item.ticketCode && QRCode.toDataURL(item.ticketCode, {margin: 2, scale: 8}).then(setTicketCodeImage)
  }, [item])

  return <Descriptions bordered>
    <Item label="票种" span={2}>{item.productName}</Item>
    <Item label="数量(张)" span={2}>{item.quantity}</Item>
    <Item label="金额(元)" span={2}>{item.price}</Item>
    <Item label="总计(元)" span={2}>{item.totalAmount}</Item>
    <Item label="购票时间" span={2}>{moment(item.ticketTime).format('Y-MM-DD HH:mm:ss')}</Item>
    <Item label="游玩日期" span={2}>{moment(item.travelDate).format('Y-MM-DD')}</Item>
    <Item label="游玩人" span={4}>{
      item.visitorList && item.visitorList.map(visitor => <span>
        {visitor.name}&nbsp;
      </span>)
    }</Item>
    <Item label="门票二维码" span={4}>
      {ticketCodeImage ? <Popover trigger="click" placement="top" content={<img src={ticketCodeImage} style={{width: 200}}/>}>
        <a>查看二维码</a>
      </Popover> : '无'}
    </Item>
    <Item label="状态" span={4}>{<TicketOrderStatus value={item.status}/>}</Item>
  </Descriptions>
}

export default Info
